import { BASE_URL, CHECKOUT_JS_URL, SHIFT4_BASE_URL, SHIFT4_CHECKOUT_JS_URL, VERSION_ID, ORIGIN_NAME } from "../env";

function tryExtractCurrentFrameBase(): string | null {
  if (typeof window === 'undefined' || !window.document) {
    return null;
  }
  const matchedBaseUrl = [BASE_URL, SHIFT4_BASE_URL].find((baseUrl: string) => {
    return window.location.href.startsWith(baseUrl);
  });
  return matchedBaseUrl ?? null;
}

function validateRelativePath(relativePath: string): void {
  if (relativePath.startsWith('/')) {
    throw new Error(`Expected path without leading slash, got: ${relativePath}`);
  }
}

export function getFrameAbsoluteUrl(relativePath: string): string {
  validateRelativePath(relativePath);

  const base = `${BASE_URL}/${VERSION_ID}`;
  return `${base}/v2/frames/${ORIGIN_NAME}/${relativePath}`;
}

export function getCheckoutUrl(): string {
  return tryExtractCurrentFrameBase() === BASE_URL ? CHECKOUT_JS_URL : SHIFT4_CHECKOUT_JS_URL;
}

export function getResourceAbsoluteUrl(relativePath: string): string {
  validateRelativePath(relativePath);

  const currentFrameBase = tryExtractCurrentFrameBase();
  if (currentFrameBase) {
    return `${currentFrameBase}/${VERSION_ID}/${relativePath}`;
  }
  return `${SHIFT4_BASE_URL}/${VERSION_ID}/${relativePath}`;
};
